// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	"UAT": {
		"enableEncDecLogin" : true,
		"CONTEXT_PATH": "eKycServices",
		"BACKEND_URL_PREFIX": "http://rsgitstm51:9010/",
		"REDIRECT_URL": "http://rsgitstm51:8090/rsdc/",
		"KYC_UPLOAD_BACK_URL": "http://rsgitstm51:9010/eKyc",
		"EAPPS_CONTEXT_PATH": "eappspolicyservices",
		"EAPPS_URL_PREFIX": "http://rsgitstm51:8090/"
	},
	"UAT_Ext": {
		"enableEncDecLogin" : true,
		"CONTEXT_PATH": "eKycServices",
		"BACKEND_URL_PREFIX": "https://ekyc.royalsundaram.net/",
		"REDIRECT_URL": "https://www.royalsundaram.net/rsdc/",
		"KYC_UPLOAD_BACK_URL": "https://ekyc.royalsundaram.net/eKyc",
		"EAPPS_CONTEXT_PATH": "eappspolicyservices",
		"EAPPS_URL_PREFIX": "https://www.royalsundaram.net/",
	},
	"STG": {
		"enableEncDecLogin" : false,
		"CONTEXT_PATH": "eKycStgServices",
		"BACKEND_URL_PREFIX": "http://rsgitstm55:9010/",
		"REDIRECT_URL": "http://rsgitstm55:8090/rsdc/",
		"KYC_UPLOAD_BACK_URL": "http://rsgitstm55:9010/eKycStg",
		"EAPPS_CONTEXT_PATH": "eappspolicyservices",
		"EAPPS_URL_PREFIX": "http://rsgitstm55:8090/",
	},
	"STG_Ext": {
		"enableEncDecLogin" : false,
		"CONTEXT_PATH": "eKycStgServices",
		"BACKEND_URL_PREFIX": "https://ekyc.royalsundaram.net/",
		"REDIRECT_URL": "https://www.royalsundaram.net/rsdc/",
		"KYC_UPLOAD_BACK_URL": "https://ekyc.royalsundaram.net/eKycStg",
		"EAPPS_CONTEXT_PATH": "eappspolicyservices",
		"EAPPS_URL_PREFIX": "https://rsauthstag.royalsundaram.net/",
	},
	"LIVE": {
		"enableEncDecLogin" : true,
		"CONTEXT_PATH": "eKycServices",
		"BACKEND_URL_PREFIX": "https://kyc.royalsundaram.in/",
		"REDIRECT_URL": "https://www.royalsundaram.in/rsdc/",
		"KYC_UPLOAD_BACK_URL": "https://kyc.royalsundaram.in/eKyc",
		"EAPPS_CONTEXT_PATH": "eappspolicyservices",
		"EAPPS_URL_PREFIX": "http://epaswsomw.ind.rsa-ins.com/"
	},
	"LIVE_Ext": {
		"enableEncDecLogin" : true,
		"CONTEXT_PATH": "eKycServices",
		"BACKEND_URL_PREFIX": "https://kyc.royalsundaram.in/",
		"REDIRECT_URL": "https://www.royalsundaram.in/rsdc/",
		"KYC_UPLOAD_BACK_URL": "https://kyc.royalsundaram.in/eKyc",
		"EAPPS_CONTEXT_PATH": "eappspolicyservices",
		"EAPPS_URL_PREFIX": "https://api.royalsundaram.in/"
	},
	"selectedEnv": "LIVE",
	"context": "eKyc"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
